import { render } from "./HeaderBlock.vue?vue&type=template&id=539e0de4&scoped=true"
const script = {}

import "./HeaderBlock.vue?vue&type=style&index=0&id=539e0de4&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-539e0de4"]])

export default __exports__